const CLICK_SOUND = new Audio(
  new URL('~/public/assets/audios/clickSound.mp3', import.meta.url).href
)

export default CLICK_SOUND
